// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"6":"e6b31b24","650":"de615654","821":"d2796f8a"}[chunkId] + ".js";
};